import script from "./LeanLawExpenseSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./LeanLawExpenseSetup.vue?vue&type=script&setup=true&lang=js"

import "./LeanLawExpenseSetup.vue?vue&type=style&index=0&id=412a7ff4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412a7ff4"]])

export default __exports__